import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import PhotoSizeSelectSmallIcon from "@mui/icons-material/PhotoSizeSelectSmall";
import { makeStyles } from "@mui/styles";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, TextField, Button } from "@mui/material";
// import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../components/Theme/WebTheme";
import { carTypeColumns, optionsRequired } from "common/sharedFunctions";
import * as yup from "yup";
import "../styles/style.css";
import Loader from "components/Loader";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarTypes() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const carlistdata = useSelector((state) => state.carlistdata);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const { editCarType, updateUserCar, editCar, uploadImage } = api;
  const [data, setData] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const [modalType, setModalType] = useState();
  const [addRowModalOpen, setAddRowModalOpen] = useState(false);
  const [newRowData, setNewRowData] = useState({});
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  const [loader, setloader] = useState(false);
  const handleAddrow = (newData) => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve, reject) => {
          setTimeout(() => {
            if (newData && newData.name) {
              newData["createdAt"] = new Date().getTime();
              dispatch(editCarType(newData, "Add"));
              resolve();
            } else {
              alert(t("proper_input_name"));
              reject();
            }
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleUpdateRow = (newData, oldData) => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          console.log(newData, " ----------- ", oldData);
          newData.id = oldData.id;
          setTimeout(() => {
            resolve();
            if (newData !== oldData) {
              delete newData.tableData;
              if (newData.name !== oldData.name) {
                let users = staticusers?.filter(
                  (user) =>
                    user.usertype === "driver" && user.carType === oldData.name
                );
                for (let i = 0; i < users?.length; i++) {
                  dispatch(
                    updateUserCar(users[i].id, {
                      carType: newData.name,
                    })
                  );
                }
                let cars = carlistdata.cars.filter(
                  (car) => car.carType === oldData.name
                );
                for (let i = 0; i < cars?.length; i++) {
                  dispatch(
                    editCar({ ...cars[i], carType: newData.name }, "Update")
                  );
                }
              }
              dispatch(editCarType(newData, "Update"));
            }
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleOpenAddRowModal = (data) => {
    setAddRowModalOpen(true);
  };

  const handleCloseModal = () => {
    setAddRowModalOpen(false);
    setNewRowData({});
  };
  const onClick = (rowData) => {
    setImageData(rowData.image);
    setProfileModal(true);
    setUserData(rowData);
  };
  const columns = carTypeColumns(t, isRTL, onClick);
  // let con = columns.forEach((val) => {
  //   return val.field != "convenience_fees";
  // });
  // console.log(con, "con");
  // console.log(columns, "columns");

  const subcolumns = [
    {
      title: t("description"),
      field: "description",
      render: (rowData) => <span>{rowData.description}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const subcolumns2 = [
    {
      title: t("minsDelayed"),
      field: "minsDelayed",
      render: (rowData) => <span>{rowData.minsDelayed}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (cartypes.cars) {
      setData(cartypes.cars);
    } else {
      setData([]);
    }
  }, [cartypes.cars]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setLoading(true);
      let finalData = userData;
      finalData.image = selectedImage;
      dispatch(editCarType(finalData, "UpdateImage"));
      setProfileModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  };

  const [selectedRow, setSelectedRow] = useState(null);

  return cartypes.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
      <MaterialTable
        //title={t('car_type')}
        title={<span className="tableTitleStyle">{t("car_type")}</span>}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "16px",
          marginTop: 20,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportButton: true,
          rowStyle: (rowData) => ({
            fontSize: "12px",
            // backgroundColor:
            //   selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            fontSize: "12px",
            fontWeight: "bold ",
            // backgroundColor: colors.Header_Text,
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            backgroundColor: "#e1e7f0",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            // backgroundColor: colors.Header_Text_back,
            // color: "#fff",
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },

          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenAddRowModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenAddRowModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve, reject) => {
          //         console.log("new CarType Add using Old fn", newData);
          //         setTimeout(() => {
          //           if (newData && newData.name) {
          //             newData["createdAt"] = new Date().getTime();
          //             dispatch(editCarType(newData, "Add"));
          //             resolve();
          //           } else {
          //             alert(t("proper_input_name"));
          //             reject();
          //           }
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          // onRowUpdate: (newData, oldData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve) => {
          //         console.log(newData, " ----------- ", oldData);
          //         setTimeout(() => {
          //           resolve();
          //           if (newData !== oldData) {
          //             delete newData.tableData;
          //             if (newData.name !== oldData.name) {
          //               let users = staticusers?.filter(
          //                 (user) =>
          //                   user.usertype === "driver" &&
          //                   user.carType === oldData.name
          //               );
          //               for (let i = 0; i < users?.length; i++) {
          //                 dispatch(
          //                   updateUserCar(users[i].id, {
          //                     carType: newData.name,
          //                   })
          //                 );
          //               }
          //               let cars = carlistdata.cars.filter(
          //                 (car) => car.carType === oldData.name
          //               );
          //               for (let i = 0; i < cars?.length; i++) {
          //                 dispatch(
          //                   editCar(
          //                     { ...cars[i], carType: newData.name },
          //                     "Update"
          //                   )
          //                 );
          //               }
          //             }
          //             dispatch(editCarType(newData, "Update"));
          //           }
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(editCarType(oldData, "Delete"));
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        // actions={[
        //   (rowData) =>
        //     optionsRequired
        //       ? {
        //           icon: () => (
        //             <div
        //               style={{
        //                 display: "flex",
        //                 alignItems: "center",
        //                 flexWrap: "wrap",
        //               }}
        //             >
        //               <PhotoSizeSelectSmallIcon />
        //               <Typography variant="subtitle2" style={{ padding: 5 }}>
        //                 {t("parcel_types")}
        //               </Typography>
        //             </div>
        //           ),
        //           onClick: (event, rowData) => {
        //             setModalType("parcelTypes");
        //             setRowIndex(rowData.tableData.id);
        //             setOpen(true);
        //           },
        //         }
        //       : null,
        //   (rowData) =>
        //     optionsRequired
        //       ? {
        //           icon: () => (
        //             <div
        //               style={{
        //                 display: "flex",
        //                 alignItems: "center",
        //                 flexWrap: "wrap",
        //               }}
        //             >
        //               <FitnessCenterIcon />
        //               <Typography variant="subtitle2" style={{ padding: 5 }}>
        //                 {t("options")}
        //               </Typography>
        //             </div>
        //           ),
        //           onClick: (event, rowData) => {
        //             setModalType("options");
        //             setRowIndex(rowData.tableData.id);
        //             setOpen(true);
        //           },
        //         }
        //       : null,
        //   (rowData) => ({
        //     icon: () => (
        //       <div
        //         style={{
        //           display: "flex",
        //           alignItems: "center",
        //           flexWrap: "wrap",
        //         }}
        //       >
        //         <CancelScheduleSendIcon />
        //         <Typography variant="subtitle2" style={{ padding: 5 }}>
        //           {t("cancelSlab")}
        //         </Typography>
        //       </div>
        //     ),
        //     onClick: (event, rowData) => {
        //       setModalType("cancelSlab");
        //       setRowIndex(rowData.tableData.id);
        //       setOpen(true);
        //     },
        //   }),
        // ]}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("car_image")}

              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: "red",
                    borderRadius: 50,
                    color: "white",
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  style={{ backgroundColor: "darkblue", color: "white" }}

                  // color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <MaterialTable
            title={
              modalType === "options"
                ? t("options")
                : modalType === "cancelSlab"
                ? t("cancelSlab")
                : t("parcel_types")
            }
            columns={modalType === "cancelSlab" ? subcolumns2 : subcolumns}
            data={
              data[rowIndex] && data[rowIndex][modalType]
                ? data[rowIndex][modalType]
                : []
            }
            options={{
              exportButton: true,
            }}
            editable={{
              onRowAdd: (newData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        let tblData = data;
                        if (!tblData[rowIndex][modalType]) {
                          tblData[rowIndex][modalType] = [];
                        }
                        tblData[rowIndex][modalType].push(newData);
                        dispatch(editCarType(tblData[rowIndex]), "Update");
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
              onRowUpdate: (newData, oldData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        if (newData !== oldData) {
                          let tblData = data;
                          tblData[rowIndex][modalType][oldData.tableData.id] =
                            newData;
                          dispatch(editCarType(tblData[rowIndex]), "Update");
                        }
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
              onRowDelete: (oldData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        let tblData = data;
                        const index = tblData[rowIndex][modalType];
                        const neTtblData = index.filter(
                          (item) =>
                            item.amount !== oldData.amount &&
                            (modalType === "cancelSlab"
                              ? item.minsDelayed !== oldData.minsDelayed
                              : item.description !== oldData.description)
                        );
                        tblData[rowIndex][modalType] = neTtblData;
                        dispatch(editCarType(tblData[rowIndex]), "Update");
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
            }}
          />
        </div>
      </Modal>
      {loader ? <Loader /> : null}

      <AddCARModel
        open={addRowModalOpen}
        onClose={handleCloseModal}
        handleAddRow={handleAddrow}
        oldData={oldData}
        editing={editing}
        setediting={setediting}
        handleUpdateRow={handleUpdateRow}
        setOlddata={setOlddata}
        uploadImage={uploadImage}
        setloader={setloader}
      />
    </div>
  );
}

const AddCARModel = ({
  open,
  onClose,
  handleAddRow,
  editing,
  oldData,
  setediting,
  handleUpdateRow,
  setOlddata,
  setloader,
  uploadImage,
}) => {
  const [baseFare, setBaseFare] = useState(oldData?.base_fare || "");
  const [convenienceFees, setConvenienceFees] = useState(
    oldData?.convenience_fees || ""
  );
  const [extraInfo, setExtraInfo] = useState(oldData?.extra_info || "");
  const [image, setImage] = useState(oldData?.image || "");
  const [sendingImage, setsendingImage] = useState("");
  const [minFare, setMinFare] = useState(oldData?.min_fare || "");
  const [name, setName] = useState(oldData?.name || "");
  const [pos, setPos] = useState(oldData?.pos || "");
  const [frontimg, setimg] = useState("");
  const [frontBlob, setfrontBlob] = useState("");
  const [backimg, setbackImg] = useState("");

  const [backBlob, setbackBlob] = useState("");
  const [ratePerHour, setRatePerHour] = useState(oldData?.rate_per_hour || "");
  const [ratePerUnitsDistance, setRatePerUnitsDistance] = useState(
    oldData?.rate_per_unit_distance || ""
  );
  const [convenienceFeeType, setConvenienceFeeType] = useState(
    oldData?.convenience_fee_type || "Flat"
  );
  const [timestamp, setTimestamp] = useState(new Date());

  const [errors, setErrors] = useState({});

  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    baseFare: yup
      .number()
      .typeError("Base Fare must be a valid number")
      .required("Base Fare is required")
      .nullable(),
    // convenienceFees: yup
    //   .number()
    //   .typeError("Convenience Fees must be a valid number")
    //   .required("Convenience Fees is required")
    //   .nullable(),
    minFare: yup
      .number()
      .typeError("Minimum Fare must be a valid number")
      .required("Minimum Fare is required")
      .nullable(),
    ratePerHour: yup
      .number()
      .required("Rate per Hour is required")
      .typeError("Rate per Hour must be a valid number")
      .nullable(),
    ratePerUnitsDistance: yup
      .number()
      .typeError("Rate per Units Distance must be a valid number")
      .required("Rate per Units Distance is required"),
    // Add other fields to the schema
  });

  const validateForm = async () => {
    try {
      await schema.validate(
        {
          name,
          baseFare,
          convenienceFees,
          minFare,
          ratePerHour,
          ratePerUnitsDistance,
        },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };

  useEffect(() => {
    if (oldData) {
      setBaseFare(oldData?.base_fare || "");
      setConvenienceFees(oldData?.convenience_fees || "");
      setExtraInfo(oldData?.extra_info || "");
      setimg(oldData?.image || "");
      setsendingImage(oldData?.image || "");
      setMinFare(oldData?.min_fare || "");
      setName(oldData?.name || "");
      setPos(oldData?.pos || "");
      setRatePerHour(oldData?.rate_per_hour || "");
      setRatePerUnitsDistance(oldData?.rate_per_unit_distance || "");
      setConvenienceFeeType(oldData?.convenience_fee_type || "");
    }
  }, [oldData]);

  const handleAddCar = async () => {
    let image;
    if (frontBlob) {
      setloader(true);
      image = await uploadImage(frontBlob);
      setloader(false);
    }
    const isValid = await validateForm();
    if (!isValid) return;

    // Perform your logic to add/update the car here
    const carData = {
      name,
      base_fare: Number(baseFare),
      convenience_fees: convenienceFees,
      extra_info: extraInfo,
      image: image ? image : sendingImage,
      min_fare: Number(minFare),
      pos: Number(pos),
      rate_per_hour: Number(ratePerHour),
      rate_per_unit_distance: Number(ratePerUnitsDistance),
      convenience_fee_type: convenienceFeeType,
      createdAt: new Date().toISOString(),
    };
    setloader(true);
    if (editing) {
      handleUpdateRow(carData, oldData);
    } else {
      handleAddRow(carData);
    }
    setloader(false);

    setediting(false);

    // Reset the form
    setBaseFare("");
    setConvenienceFees("");
    setExtraInfo("");
    setImage("");
    setMinFare("");
    setName("");
    setPos("");
    setRatePerHour("");
    setRatePerUnitsDistance("");
    setimg("");
    setsendingImage("");
    // Close the modal
    onClose();
  };

  const handleClose = () => {
    // Reset the form
    setBaseFare("");
    setConvenienceFees("");
    setExtraInfo("");
    setImage("");
    setMinFare("");
    setName("");
    setPos("");
    setRatePerHour("");
    setRatePerUnitsDistance("");
    setediting(false);
    setErrors("");
    setOlddata("");
    setsendingImage("");
    setimg("");
    setsendingImage("");
    // Close the modal
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modal-container"
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "3vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "scroll",
          maxHeight: "90vh", // Add max height for scrolling
          scrollbarWidth: "thin", // Width of the scrollbar
          scrollbarColor: "#888 #f1f1f1", // Color of the scrollbar thumb and track
        }}
      >
        <h2>{editing ? "Edit" : "Add"} Car</h2>
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={errors.name !== undefined}
          helperText={errors.name}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />

        <TextField
          label="Extra Information"
          value={extraInfo}
          onChange={(e) => setExtraInfo(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        {/* <TextField
          label="Image"
          value={image}
          onChange={(e) => setImage(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        /> */}

        <TextField
          label="List Position"
          type="number"
          value={pos}
          onChange={(e) => setPos(e.target.value)}
          error={errors.pos !== undefined}
          helperText={errors.pos}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <TextField
            label="Base Fare"
            type="number"
            value={baseFare}
            onChange={(e) => setBaseFare(e.target.value)}
            error={errors.baseFare !== undefined}
            helperText={errors.baseFare}
            required
            style={{ marginBottom: "10px" }}
          />
          {/* <TextField
            label="Convenience Fees"
            type="number"
            value={convenienceFees}
            onChange={(e) => setConvenienceFees(e.target.value)}
            error={errors.convenienceFees !== undefined}
            helperText={errors.convenienceFees}
            required
            style={{ marginBottom: "10px" }}
          /> */}
          <TextField
            label="Minimum Fare"
            type="number"
            value={minFare}
            onChange={(e) => setMinFare(e.target.value)}
            error={errors.minFare !== undefined}
            helperText={errors.minFare}
            required
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="Rate per Hour"
            type="number"
            value={ratePerHour}
            onChange={(e) => setRatePerHour(e.target.value)}
            error={errors.ratePerHour !== undefined}
            helperText={errors.ratePerHour}
            required
            style={{ marginBottom: "10px" }}
          />
        </div>

        {/* <div style={{ width: "100%", marginBottom: "20px" }}> */}
        {/* <label style={{ color: "gray", fontSize: 15 }}>
            Select Convenience Fee Type:
          </label> */}
        {/* <select
            value={convenienceFeeType}
            onChange={(e) => setConvenienceFeeType(e.target.value)}
            onFocus={(e) => {
              e.target.style.borderColor = "blue"; // Change border color on focus
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#ccc"; // Restore border color on blur
            }}
            style={{
              width: "100%",
              padding: 17,
              borderRadius: 120,
              border: "1px solid #ccc",
              marginTop: "5px",
              color: "gray",
              backgroundColor: "transparent",
              borderInlineEndColor: "gray",
            }}
          >
            <option value="">Convenience Fee Type</option>
            <option value="Flat">Flat</option>
            <option value="Percentage">Percentage</option>
          </select> */}
        {/* </div> */}
        <TextField
          label="Distance Rate Per (Km or mile)"
          type="number"
          value={ratePerUnitsDistance}
          onChange={(e) => setRatePerUnitsDistance(e.target.value)}
          error={errors.ratePerUnitsDistance !== undefined}
          helperText={errors.ratePerUnitsDistance}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <label
            htmlFor="licenseFront"
            style={{
              color: "gray",
              fontSize: 13,
              marginBottom: 10,
              marginLeft: 20,
            }}
          >
            Image
          </label>
          <input
            accept="image"
            type="file"
            id="licenseFront"
            style={{
              padding: 10,
              // border: "1px solid gray",
              color: "gray",
              borderRadius: 12,
              opacity: 0.4,
            }}
            onChange={(e) => {
              setfrontBlob(e.target.files[0]);
              setimg(URL.createObjectURL(e.target.files[0]));
            }}
          />
        </div>
        {frontimg ? (
          <img
            src={frontimg}
            onClick={() => setimg("")}
            style={{
              width: 100,
              height: 110,
              border: "1px solid gray",
              borderRadius: 12,
            }}
            alt="frontimg"
          />
        ) : null}
        <div className="button-container" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handleAddCar}
            style={{ backgroundColor: "darkblue", color: "white" }}
          >
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
